import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class TurnOverDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"BALLE PERDUE"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "BALLE PERDUE",
            player: event.detail?.player,
            reason: event.detail?.reason,
          };
    }

    get player() {
        return this.detail.player;
    }
    set player(value) {
        this.detail.player = value;
    }

    get reason() {
        return this.detail.reason;
    }
    set reason(value) {
        this.detail.reason = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "player", "reason"].includes(key)){
            let commentaire = "Balle perdue"

            const team = getTeam(this.team, match)
            const player = getPlayer(this.player, match, team)

            if(this.player){
                if(player){
                    commentaire += ' pour '+ player.lastname
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "! "

            if(this.reason){
                switch(this.reason){
                    case 'badPass':
                        commentaire+='Raison : Mauvaise passe.'
                    break
                    case 'interception':
                        commentaire+='Raison : Interception par l\'adversaire.'
                    break
                    case 'footFault':
                        commentaire+='Raison : Faute de pied.'
                    break
                    case 'traveling':
                        commentaire+='Raison : Marcher avec la balle.'
                    break
                    case 'doubleDribble':
                        commentaire+='Raison : Double dribble.'
                    break
                    case 'offensiveFoul':
                        commentaire+='Raison : Faute offensive.'
                    break
                    case 'ballOutOfBounds':
                        commentaire+='Raison : Balle sortie des limites.'
                    break
                }
            }

            this.text = commentaire
        }
    }
}